import { render, staticRenderFns } from "./topo.vue?vue&type=template&id=3bcde2ba"
import script from "./topo.vue?vue&type=script&lang=js"
export * from "./topo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports